<template>
  <div class="container">
    <div class="btn-wrapper">
      <el-button type="primary" size="mini" @click="back">
        <i class="el-icon-back"></i>返回新建任务
      </el-button>
      <el-badge class="mark" :value="taskUUIDForTrainList.length">
        <el-button type="success" size="mini" @click="userSelectTrain">使用选择的批次进行训练
      </el-button>
      </el-badge>
    </div>
    <el-tabs v-model="activeTab" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="用于训练的批次" name="use">
        <cardTable :list="taskListGroup['1']" @selectionChange=" (list) => handleSelect(list, 0)"
                   :active-tab="activeTab"
                   @refresh="getTaskList"></cardTable>
      </el-tab-pane>
      <el-tab-pane label="不用于训练的批次" name="unuse">
        <cardTable :list="taskListGroup['-1']" :active-tab="activeTab"
                   @selectionChange="(list) => handleSelect(list, 1)"
                   @refresh="getTaskList"></cardTable>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import cardTable from './cardTable';
import {mapGetters, mapMutations} from 'vuex';
import moment from 'moment';
import {apiGetCheckedImgByTaskId, apiGetTaskListBeforeNewTask} from '@/api';

export default {
  name: "taskHistoryByBatch",
  components: {
    cardTable
  },
  data() {
    return {
      activeTab: "use",
      search: "",
      markerList: [],
      marker: {},
      showType: [],
      taskHistory: [],
      taskList: [],
      typeList: [{ label: "采集", value: "1" }, { label: "回测", value: "2" }]
    };
  },
  created() {
    this.setSubTitle("历史任务审查");
    this.$eventHub.$on('taskReviewed', (label_task_uuid) => {
      console.log('aaaaaaaaa', label_task_uuid);
      let res = this.$_.find(this.taskList, (a) => {
        return a.label_task_uuid === label_task_uuid;
      });
      if (res) {
        this.$set(res, 'who_review', this.username);
        this.$set(res, 'train_check_state', "1");
      }
    });
  },
  mounted() {
    this.resetTaskUUIDForTrainList();
    this.getTaskList();
    if (this.$store.state.activeTable) {
      this.activeTab = this.$store.state.activeTable;
    }
  },
  activated() {
    if (!this.$route.meta.isBack) {
      // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
      this.getTaskList();
    }
    console.log('assssssssssssssss');
    // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
    this.$route.meta.isBack = false;
  },
  methods: {
    ...mapMutations([
      "setSubTitle",
      "setCurrentCheckTaskInfo",
      "emitLoading",
      "setActiveTab",
      'setTaskUUIDForTrainList',
      'resetTaskUUIDForTrainList'
    ]),
    reset () {
      this.resetTaskUUIDForTrainList();
    },
    handleSelect (list, idx) {
      console.log('saaaaaaaa');
      this.setTaskUUIDForTrainList({idx, list});
    },
    userSelectTrain () {
      this.$router.push({
          name: 'trainTask',
          params: {
            selfCheck: true
          }
        }
      );
    },
    back() {
      this.$router.push({
        name: "trainTask",
        params: {
          selfCheck: true
        }
      });
    },
    handleClick() {
      this.emitLoading(500);
    },
    async getTaskList() {
      try {
        let res = await apiGetTaskListBeforeNewTask(this.dish_uuid_list);
        this.taskList = res.label_task_info_list;
        console.log(res);
      } catch (e) {
        console.log(e);
        this.$message.error("批次列表获取失败");
      }
    },
    assignment() {
      this.$message.error("此功能正在开发中......");
    },
    // 回看
    async reCheck(row) {
      this.$message.warning("正在跳转..");
      // if (row.label_source === '1') {
      //   return this.$message.error('采集数据回看功能还在开发');
      // }
      this.$router.push({
        name: "taskHistoryRecheck",
        params: {
          taskInfo: row,
          checkMode: false
        }
      });
    },
    async getTaskInfo(row) {
      await apiGetCheckedImgByTaskId(row.label_task_uuid);
    },
    goCheck(row) {
      return this.$message.error("还未完成");
      // eslint-disable-next-line
      this.$router.push({
        name: "taskHistoryRecheck",
        params: {
          taskInfo: row,
          checkMode: true
        }
      });
    }
  },
  filters: {
    tsToDate(ts) {
      return moment(ts * 1000).format("YYYY-MM-DD HH:mm");
    }
  },
  computed: {
    ...mapGetters(["userinfo", "listQuery", "cachedDishList", 'taskUUIDForTrainList']),
    taskListGroup() {
      return this.$_.groupBy(this.filterList, "trainable");
    },
    dish_uuid_list() {
      return this.cachedDishList.map(a => a.class_id);
    },
    isSuperUser() {
      return this.userGroup === 1000;
    },
    apiKey() {
      return this.userinfo().api_key;
    },
    userGroup() {
      return this.userinfo().userGroup;
    },
    username () {
      return this.userinfo().username;
    },
    taskUUIDForTrainListFlatten () {
      return this.taskUUIDForTrainList;
      // let list = ;
      // return () => {
      //  return this.$_.flatten(this.taskUUIDForTrainList);
      // };
      // return [...this.taskUUIDForTrainList[0], ...this.taskUUIDForTrainList[1]];
    },
    handlerOptions() {
      return {
        key: ""
      };
    },
    filterList() {
      let search = this.search;
      let list = this.taskList;
      list.sort((a, b) => {
        return -a.day_ts + b.day_ts;
      });
      return list;
    },
    count() {
      return this.$_.groupBy(this.filterList, "label_source");
    }
  },
  watch: {
    listQuery: {
      deep: true
    }
  },
  beforeDestroy() {
    this.setActiveTab(this.activeTab);
  }
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  .btn-wrapper {
    position: absolute;
    left: 300px;
    top: 5px;
    z-index: 10;
  }
}
</style>
